/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppEntriesEntryIdRouteImport } from './routes/_app/entries/$entryId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppEntriesEntryIdRoute = AppEntriesEntryIdRouteImport.update({
  id: '/entries/$entryId',
  path: '/entries/$entryId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/projects/': typeof AppProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/settings': typeof AppSettingsRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/projects': typeof AppProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/settings': typeof AppSettingsRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/entries/$entryId': typeof AppEntriesEntryIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/users'
    | '/entries/$entryId'
    | '/projects/$projectId'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/settings'
    | '/users'
    | '/'
    | '/entries/$entryId'
    | '/projects/$projectId'
    | '/projects'
  id:
    | '__root__'
    | '/_app'
    | '/_app/settings'
    | '/_app/users'
    | '/_app/'
    | '/_app/entries/$entryId'
    | '/_app/projects/$projectId'
    | '/_app/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/entries/$entryId': {
      id: '/_app/entries/$entryId'
      path: '/entries/$entryId'
      fullPath: '/entries/$entryId'
      preLoaderRoute: typeof AppEntriesEntryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSettingsRoute: typeof AppSettingsRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
  AppEntriesEntryIdRoute: typeof AppEntriesEntryIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSettingsRoute: AppSettingsRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
  AppEntriesEntryIdRoute: AppEntriesEntryIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
